import { ACTIONS as logoutActions } from 'actions/logout';
import { ACTIONS as classRecordingActions } from 'actions/student-class-recordings';
import { errors } from 'redux-rest-reducer';

export const initialState = {
  recordingsList: [],
  totalPage: null,
  isLoaded: false,
  isLoading: false,
  isLoadingFailed: false,
};

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === classRecordingActions.GET) {
    return {
      ...state,
      isLoaded: false,
      isLoading: true,
      isLoadingFailed: false,
    };
  }

  if (type === classRecordingActions.GET_SUCCESS) {
    const {
      value: {
        teacher_classrooms: teacherClassroomsRecordings = [],
        total_count: totalCount,
      },
    } = payload;

    return {
      ...state,
      recordingsList: [...state.recordingsList, ...teacherClassroomsRecordings],
      totalPage: Number(totalCount),
      isLoaded: true,
      isLoading: false,
      isLoadingFailed: false,
    };
  }

  if (type === logoutActions.POST_SUCCESS || type === errors[401]) {
    return initialState;
  }

  return state;
}
